import { ScanDataPoint } from '@willie/schemas'
import { useState } from 'react'
import { WaterStation } from '~/features/stations/schemas'
import { Dialog } from '@radix-ui/themes'
import DatapointForm from './DatapointForm'

interface EditDatapointDialogProps {
  children: React.ReactElement
  datapoint: ScanDataPoint
  onSave: (datapoint: ScanDataPoint) => void
  stations: WaterStation[]
}

const EditDatapointDialog = ({ children, datapoint, onSave, stations }: EditDatapointDialogProps) => {
  const [open, setOpen] = useState(false)
  const [isPending, setIsPending] = useState(false)

  const handleSubmit = async (updatedDatapoint: ScanDataPoint) => {
    try {
      setIsPending(true)
      onSave(updatedDatapoint)
      setOpen(false)
    } catch (error) {
      console.error('Error updating datapoint', error)
    } finally {
      setIsPending(false)
    }
  }

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>{children}</Dialog.Trigger>
      <Dialog.Content style={{ zIndex: 1000 }}>
        <Dialog.Title>Modifier le point de données</Dialog.Title>
        <DatapointForm datapoint={datapoint} stations={stations} onSubmit={handleSubmit} isPending={isPending} />
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default EditDatapointDialog
